

import React from 'react'

function LoadingScreen() {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p className="loading-text">กำลังโหลดข้อมูล...</p>
    </div>
  )
}

export default LoadingScreen